import React from "react";
import { graphql } from "gatsby";
import { AuthorPage } from "../components/author-page";
import { LayoutContainer } from "../containers/layout";
import PageHeadMeta from "../components/global/page-head-meta";

export const query = graphql`
  query AuthorTemplateQuery($id: String!, $_id: String!) {
    doc: sanityAuthor(id: { eq: $id }) {
      _type
      _id
      name
      title
      url
      twitter
      linkedin
      image {
        ...SanityImage
        alt
      }
      _rawBio
      companies {
        title
        mainImage {
          ...SanityImageSimple
        }
      }
    }
    posts: allSanityPost(
      sort: { fields: [publishedAt], order: DESC }
      filter: {
        slug: { current: { ne: null } }
        status: { eq: "published" }
        authors: { elemMatch: { author: { _id: { eq: $_id } } } }
      }
    ) {
      edges {
        node {
          ...cardNode
        }
      }
    }
  }
`;

const AuthorTemplate = ({ data }) => (
  <LayoutContainer doc={data.doc}>
    <PageHeadMeta title={`${data.doc.name} — Blog Posts`} doc={data.doc} />
    {data.doc && <AuthorPage doc={data.doc} posts={data.posts} />}
  </LayoutContainer>
);

export default AuthorTemplate;
